import styled from "styled-components";
import { Toggle } from "../../toggle";
export const StyledToggle = styled(Toggle) `
  svg {
    fill: white;
  }
`;
